/**
 * FormBuilder field config for duration (numberStepper).
 * Generic — name and label must be provided by consumer.
 */
import { useMemo } from 'react';

interface UseDurationFieldConfigProps {
  name: string;
  label: string;
  condition?: Record<string, unknown>;
  min?: number;
  max?: number;
  step?: number;
  unitLabel?: string;
}

export function useDurationFieldConfig(props: UseDurationFieldConfigProps) {
  const fieldConfig = useMemo(
    () => ({
      type: 'numberStepper' as const,
      name: props.name,
      label: props.label,
      condition: props.condition,
      fieldProps: {
        step: props.step ?? 15,
        min: props.min ?? 15,
        max: props.max ?? 1440,
        unitLabel: props.unitLabel ?? 'mins',
      },
    }),
    [
      props.name,
      props.label,
      props.condition,
      props.step,
      props.min,
      props.max,
      props.unitLabel,
    ]
  );

  return { fieldConfig };
}
